"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnSeat = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const tariffGroupMapper_1 = require("../../../../../TariffsTable/tariffGroupMapper");
require("./index.scss");
const className = 'flight-passenger-list-seat';
const ColumnSeat = (props) => {
    const { onSeatClick = () => undefined, disabled = () => false, } = props !== null && props !== void 0 ? props : {};
    return {
        id: 'Seat',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Seat:Title', defaultMessage: 'Seat' })),
        Cell: ({ row }) => {
            var _a;
            const { seatLabel } = row.original;
            const disabledItem = disabled(row.original);
            const tariffCode = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)((_a = row.original.tariff) === null || _a === void 0 ? void 0 : _a.group.id);
            const classNames = (0, classFunctions_1.getClassNames)(className, [
                (tariffCode && seatLabel) ? tariffCode : undefined,
                disabledItem ? 'disabled' : undefined,
            ]);
            const handleSeatClick = () => onSeatClick(row.original);
            return (react_1.default.createElement("div", { className: classNames, style: disabledItem ? { cursor: 'not-allowed' } : undefined },
                react_1.default.createElement("div", { className: `${className}__number`, onClick: handleSeatClick, style: disabledItem ? { pointerEvents: 'none', cursor: 'not-allowed' } : undefined }, seatLabel)));
        },
    };
};
exports.ColumnSeat = ColumnSeat;
//# sourceMappingURL=index.js.map